import { IContentHubClient } from "../../clients/content-hub-client";
import Guard from "../../guard";
import { QueryResultBase } from "./entity-query-result";
import { EntityIdIterator, IIdIterator } from "./id-iterator";
import { Query } from "./query";
import { IQueryResult } from "./query-result";

export interface IIdQueryResult extends IQueryResult<number> {
    createIterator(): IIdIterator;
}

export class EntityIdQueryResult extends QueryResultBase<number> implements IIdQueryResult {
    private readonly _client: IContentHubClient;
    private readonly _query: Query;

    items: Array<number>;

    constructor(client: IContentHubClient, query: Query, ids: Array<number>, totalItems: number, offset: number) {
        super(totalItems, offset);
        Guard.notNullOrUndefined(client);
        Guard.notNullOrUndefined(query);
        Guard.notNullOrUndefined(ids);

        this._client = client;
        this._query = query;
        this.items = ids;
    }

    createIterator(): IIdIterator {
        return new EntityIdIterator(this._client, this._query, this);
    }
}
